export default __webpack_public_path__ + "img/save.95fe33b4.svg";